<div #tabContent *ngIf="tabs?.isDisplay || isActive" class="my-2 tab-pane" [class.active]="isActive" [class.show]="isActive" [class.d-none]="!isActive" [id]="key">
    <ng-container *ngIf="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{}"></ng-container>
    <ng-content></ng-content>
</div>